export const slugify = (value: string, maxLength = 80): string =>
    value
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, maxLength)
        .replace(/-+$/g, '')

/** Small, stable, non-cryptographic hash (FNV-1a, 32 bit) as hex. */
export const hashString = (value: string): string => {
    let hash = 0x811c9dc5

    for (let index = 0; index < value.length; index++) {
        hash ^= value.charCodeAt(index)
        hash = Math.imul(hash, 0x01000193)
    }

    return (hash >>> 0).toString(16).padStart(8, '0')
}

export const escapeRegex = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const escapeHtml = (value: string): string =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')

export const collapseWhitespace = (value: string): string => value.replace(/\s+/g, ' ').trim()

export const truncate = (value: string, max: number): string =>
    value.length <= max ? value : `${value.slice(0, Math.max(0, max - 1)).trimEnd()}…`

export const initials = (value: string): string => {
    const words = value.trim().split(/\s+/).filter(Boolean)
    if (words.length === 0) return '?'
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
    return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase()
}

export const firstName = (value: string): string => value.trim().split(/\s+/)[0] ?? ''

export const isEmail = (value: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())

export const uniqueStrings = (values: Array<string>): Array<string> => {
    const seen = new Set<string>()
    const result: Array<string> = []

    for (const value of values) {
        const key = value.trim().toLowerCase()
        if (!key || seen.has(key)) continue
        seen.add(key)
        result.push(value.trim())
    }

    return result
}
